// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2347":"5d33759d","3613":"5d33759d","7742":"71dcd781"}[chunkId] + ".chunk.css";
};